import { NAME } from './constants';

export const SUBMIT_REGISTRATION_FORM = `${NAME}.SUBMIT_REGISTRATION_FORM`;
export const SIGN_UP_WITH_GOOGLE = `${NAME}.SIGN_UP_WITH_GOOGLE`;
export const SIGN_UP_WITH_APPLE = `${NAME}.SIGN_UP_WITH_APPLE`;
